/**
 * Whether « Activer les notifications » opens on the way into the app.
 *
 * It used to open whenever the API held no push token for the account. The
 * 2.2.11 test campaign saw it on the first visit to the profile right after
 * iOS permission had been granted: the token is saved only once the phone
 * hands one over, which a simulator never does and a real phone can fail to
 * do. Asking again somebody who already said yes is a page for nothing, so
 * the system's answer wins; the token is then requested again without asking.
 */
export const asksForNotifications = (where: { theApiHasAToken: boolean; theSystemSaidYes: boolean }): boolean =>
  !where.theApiHasAToken && !where.theSystemSaidYes;
